export type DeploymentEnv = 'prd' | 'stg' | 'tst' | 'dev' | 'local'

export const isProduction = () => process.env.NEXT_PUBLIC_DEPLOYMENT === 'prd'
export const isStaging = () => process.env.NEXT_PUBLIC_DEPLOYMENT === 'stg'
export const isTest = () => process.env.NEXT_PUBLIC_DEPLOYMENT === 'tst'
export const isDevelopment = () => process.env.NEXT_PUBLIC_DEPLOYMENT === 'dev'

export const getClientDeploymentEnv = () => {
  const deploymentEnv = process.env.NEXT_PUBLIC_DEPLOYMENT as DeploymentEnv | undefined
  return deploymentEnv ?? 'local'
}

export const isClientDeploymentEnv = (env: DeploymentEnv | Array<DeploymentEnv>) => {
  const envsToCheck = Array.isArray(env) ? env : [env]
  const currentEnv = getClientDeploymentEnv()
  return envsToCheck.includes(currentEnv)
}
